import { SearchUserEnriched } from 'lib-search-types';

type CanMakeInternalCallParams = {
  member: SearchUserEnriched;
  isOwnAgent: boolean;
  isMicrophoneBlocked: boolean;
};

export const canMakeInternalCall = ({
  member,
  isOwnAgent,
  isMicrophoneBlocked,
}: CanMakeInternalCallParams): boolean => {
  const hasActivePhoneCall = (member.active_phone_calls?.length ?? 0) > 0;
  const isOffline = !member.is_online;
  const hasPhoneDisabled = !member.working_media_types?.includes('speak');

  return !(
    hasActivePhoneCall ||
    isMicrophoneBlocked ||
    isOwnAgent ||
    isOffline ||
    hasPhoneDisabled
  );
};
